export const StatesTabs = ({ tabs, activeState, setActiveState }: { tabs: any[], activeState: string, setActiveState: any }) => {
    return (
        <div className='tabs_state'>
            {tabs.map((t, i) => (
                <div className={`tab ${t.id === activeState && "active"}`} key={i} onClick={() => setActiveState(t.id)}>
                    <div>{t.name}</div>
                    {t.amountElement ? (<div className={`numberItems ${t.id === activeState && "active"}`} >{t.amountElement}</div>) : null}
                </div>
            ))}
        </div>)
}